<template>
    <div>
        <media :source="options.media" v-if="options.media"/>
    </div>
</template>
<script>
    import Breadcrumb from '@/components/breadcrumb'
    import Media from '@/components/media'
    import AppButton from '@/components/app-button/index'
    import PageComponentTemplate from '../page-component-template';

    export default {
        name: 'page-component-full-media',
        extends: PageComponentTemplate,
        components: {
            Breadcrumb,
            Media,
            AppButton
        },
        methods: {
            onClickStart() {
                this.$gameClient.send({
                    _currentPageIndex: this.currentPageIndex + 1
                })
            }
        }
    }
</script>
<style lang="less" scoped>
</style>